import axios from 'axios'
import { REACT_APP_API } from '../../config'
import { toast } from 'react-toastify'

export default async function saveMeliCode(meliUriCode, meliCode) {
    const accountBody = {
        code: meliCode,
        meli_uri_code: meliUriCode
    }

    try {
        const response = await axios.put(
            `${REACT_APP_API}/integrations/meli/completeRegistration`,
            accountBody
        )
        
        return response.data;
    } catch (error) {
        // Si vuelve un error con mensaje mensaje del backend, se usa ese mensaje
        if (error?.response?.data?.message)
            error.message = error.response.data.message
        toast.error(error.message)
        return false
    }
}
